/**
 * User-facing messages for itinerary draft creation API errors.
 */
export function resolveItineraryFriendlyErrorMessage(
  response = {},
  fallback = "Failed to generate itinerary draft."
) {
  const rawError = String(response?.error || "").toLowerCase();
  const detailMessage = String(response?.details?.openAiMessage || response?.details?.message || "");
  const combined = `${rawError} ${detailMessage.toLowerCase()}`;

  if (
    combined.includes("invalid itinerary plan")
    || combined.includes("must not have fewer than 1 items")
    || combined.includes("no itinerary")
  ) {
    return "We could not read itinerary details from this file. Please upload a valid trip PDF or .eml with day-wise itinerary details.";
  }

  if (combined.includes("invalid pdf") || combined.includes("pdf")) {
    return "Invalid PDF file. Please upload a readable trip PDF or .eml file.";
  }

  return response?.error || fallback;
}
